export enum WorkflowState {
  RUNNING = 'running',
  COMPLETED = "COMPLETED",
  COMPLETED_SUCCESSFUL = "completed_successful",
  COMPLETED_UNSUCESSFUL = "completed_unsuccessful",
  CANCELLED = "cancelled"
}
